import {
  BaseModalBody,
  BaseModalFooter,
  BaseModalHeader,
} from "@src/common/components";
import CourieButton from "@src/common/components/Button/Button";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import EditOrderForm from "../editOrderModal/EditOrderForm";
import useEditOrderFormSubmit from "../../hooks/useEditOrderFormSubmit";
import { StopOrderEditing } from "@src/shipments/features/stopReordering";
import { EditOrderModalSlides } from "./EditOrderModal";
import useReadyTimeValidation from "../../hooks/useReadyTimeValidation";
import { EditOrderShipment } from "./hooks/useEditOrderShipment";

interface Props {
  onConfirm: () => void;
  setIsModalOpen: (value: boolean) => void;
  shouldChangeRoute: boolean;
  setCurrentSlide: React.Dispatch<React.SetStateAction<EditOrderModalSlides>>;
  selectedDuration: string;
  setSelectedDuration: React.Dispatch<React.SetStateAction<string>>;
  onStopDateChange: () => void;
  isDifferentStopDate: boolean;
  shipment: EditOrderShipment;
  stopOrderEditing?: StopOrderEditing;
  refetchShipment?: () => Promise<unknown>;
  onSubmittingChange: (isSubmitting: boolean) => void;
}

const EditOrderSlide = ({
  onConfirm,
  setIsModalOpen,
  shouldChangeRoute,
  setCurrentSlide,
  selectedDuration,
  setSelectedDuration,
  onStopDateChange,
  isDifferentStopDate,
  shipment,
  stopOrderEditing,
  refetchShipment,
  onSubmittingChange,
}: Props) => {
  const { handleSubmit, reset } = useFormContext();
  const { onSubmit, loading, stopIdsToDelete, setStopIdsToDelete } =
    useEditOrderFormSubmit({
      onConfirm,
      reset,
      setCurrentSlide,
      isDifferentStopDate,
      shipment,
      stopOrderEditing,
      refetchShipment,
      onSubmittingChange,
    });
  const [isAllStopsHaveAddress, setIsAllStopsHaveAddress] = useState(false);
  const [hasPackageValidationError, setHasPackageValidationError] =
    useState(false);
  const [arePackageTypesLoading, setArePackageTypesLoading] = useState(false);
  const { checkIfReadyTimeIsRequired } = useReadyTimeValidation();

  return (
    <>
      <BaseModalHeader>Edit order #{shipment?.order.displayId}</BaseModalHeader>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // Enter in any field submits the form directly, past the submit
          // button's disabled state, so gate the package-type load here too.
          if (arePackageTypesLoading) return;
          const isEligibleToSubmit = checkIfReadyTimeIsRequired();
          if (isEligibleToSubmit) {
            handleSubmit(onSubmit)();
          }
        }}
      >
        <BaseModalBody
          style={{ minWidth: 1200, height: "70vh", overflow: "scroll" }}
        >
          <EditOrderForm
            stopIdsToDelete={stopIdsToDelete}
            setStopIdsToDelete={setStopIdsToDelete}
            setIsAllStopsHaveAddress={setIsAllStopsHaveAddress}
            selectedDuration={selectedDuration}
            setSelectedDuration={setSelectedDuration}
            onStopDateChange={onStopDateChange}
            shipment={shipment}
            setHasPackageValidationError={setHasPackageValidationError}
            setArePackageTypesLoading={setArePackageTypesLoading}
            isStopOrderEditable={!!stopOrderEditing}
          />
        </BaseModalBody>
        <BaseModalFooter className=" col-span-2 flex justify-between">
          <CourieButton
            color={"secondary"}
            onClick={() => setIsModalOpen(false)}
            disabled={loading}
          >
            Cancel
          </CourieButton>
          <CourieButton
            isProcessing={loading || arePackageTypesLoading}
            type="submit"
            disabled={
              !isAllStopsHaveAddress || hasPackageValidationError || loading
            }
          >
            {shouldChangeRoute ? "Submit & Change Route" : "Submit"}
          </CourieButton>
        </BaseModalFooter>
      </form>
    </>
  );
};

export default EditOrderSlide;
